export const FlexibleDates = {
    FAILED: 'FAILED_FLEXIBLE_DATES',
    REQUEST: 'REQUEST_FLEXIBLE_DATES',
    RECEIVE: 'RECEIVE_FLEXIBLE_DATES',
};
